export const COMMUNICATION_PRESS = "COM_PRESS";
export const MARKETING_AND_UX = "MARKETING_AND_UX";
